import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendActiveIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.49952 14.5001L19.9995 4.00005M9.6271 14.8281L12.2552 21.5861C12.4867 22.1815 12.6025 22.4791 12.7693 22.566C12.9139 22.6414 13.0862 22.6415 13.2308 22.5663C13.3977 22.4796 13.5139 22.1821 13.7461 21.587L20.3364 4.69925C20.5461 4.16207 20.6509 3.89348 20.5935 3.72185C20.5437 3.5728 20.4268 3.45583 20.2777 3.40604C20.1061 3.34871 19.8375 3.45352 19.3003 3.66315L2.41258 10.2535C1.8175 10.4857 1.51997 10.6018 1.43326 10.7687C1.35809 10.9134 1.35819 11.0857 1.43353 11.2303C1.52043 11.3971 1.81811 11.5128 2.41345 11.7444L9.17146 14.3725C9.29231 14.4195 9.35273 14.443 9.40361 14.4793C9.44871 14.5114 9.48815 14.5509 9.52031 14.596C9.55661 14.6468 9.58011 14.7073 9.6271 14.8281Z",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSendActiveIcon;
